/**
 * QuestSystem — Procedural quests from villagers.
 *
 * MINECRAFT DOESN'T HAVE THIS. FedeWorld does.
 *
 * Villagers offer randomly-generated quests:
 * - Combat: "Mata 5 zombies"
 * - Gather: "Tráeme 10 trigo"
 * - Explore: "Visita el Nether"
 * - Build: "Construye una torre de 10 bloques de altura"
 *
 * Complete quests for emeralds + XP.
 */

const QUEST_TEMPLATES = [
  // Combat quests
  { type: 'kill', target: 'ZOMBIE', count: 5, reward: 2, xp: 20, name: 'Cazador de No-Muertos',
    desc: 'Mata {count} zombies' },
  { type: 'kill', target: 'SKELETON', count: 3, reward: 3, xp: 15, name: 'Arquero Implacable',
    desc: 'Mata {count} esqueletos' },
  { type: 'kill', target: 'CREEPER', count: 2, reward: 4, xp: 25, name: 'Desactivador de Bombas',
    desc: 'Mata {count} creepers sin morir' },
  { type: 'kill', target: 'SPIDER', count: 4, reward: 2, xp: 15, name: 'Aracnófobo',
    desc: 'Mata {count} arañas' },

  // Gather quests
  { type: 'gather', item: 'WHEAT_ITEM', count: 10, reward: 1, xp: 10, name: 'Granjero Mayor',
    desc: 'Tráeme {count} trigo' },
  { type: 'gather', item: 'COAL', count: 15, reward: 2, xp: 15, name: 'Minero de Carbón',
    desc: 'Tráeme {count} carbón' },
  { type: 'gather', item: 'IRON_INGOT', count: 5, reward: 3, xp: 20, name: 'Herrero Aprendiz',
    desc: 'Tráeme {count} lingotes de hierro' },
  { type: 'gather', item: 'DIAMOND_GEM', count: 1, reward: 5, xp: 50, name: 'Cazador de Diamantes',
    desc: 'Tráeme un diamante' },
  { type: 'gather', item: 'RAW_BEEF', count: 8, reward: 2, xp: 15, name: 'Carnicero',
    desc: 'Tráeme {count} carne cruda' },

  // Mine quests
  { type: 'mine', blockId: 3, count: 50, reward: 2, xp: 15, name: 'Picapedrero',
    desc: 'Mina {count} bloques de piedra' },
  { type: 'mine', blockId: 5, count: 20, reward: 2, xp: 15, name: 'Leñador',
    desc: 'Tala {count} bloques de madera' },

  // Explore quests
  { type: 'explore', target: 'nether', reward: 4, xp: 30, name: 'Explorador Infernal',
    desc: 'Visita el Nether' },
  { type: 'explore', target: 'end', reward: 8, xp: 60, name: 'Viajero del End',
    desc: 'Visita The End' },
];

export class QuestSystem {
  constructor() {
    this.activeQuests = []; // { id, type, target, count, progress, reward, xp, name, desc, giverId }
    this.completedCount = 0;
    this._nextId = 1;
    this._buildUI();
  }

  _buildUI() {
    // Persistent quest tracker in top-left
    this._tracker = document.createElement('div');
    this._tracker.style.cssText = `
      position:fixed; top:80px; right:10px; width:240px;
      background:rgba(0,0,0,0.6); border:2px solid #FFD700;
      padding:8px 12px; font-family:'Courier New',monospace;
      color:#FFF; font-size:12px; z-index:150;
      display:none;
    `;
    document.body.appendChild(this._tracker);

    // Quest log screen (full view)
    this._overlay = document.createElement('div');
    this._overlay.style.cssText = `
      position:fixed; top:0; left:0; width:100%; height:100%;
      background:rgba(0,0,0,0.75); z-index:912; display:none;
      justify-content:center; align-items:center;
    `;

    const panel = document.createElement('div');
    panel.style.cssText = `
      background:#2A2A2A; border:4px solid #B8860B;
      padding:24px; min-width:500px; max-width:600px;
      font-family:'Courier New',monospace; color:#DDD;
    `;

    const title = document.createElement('div');
    title.textContent = '📜 Diario de Misiones';
    title.style.cssText = 'font-size:22px;font-weight:bold;color:#FFD700;margin-bottom:16px;text-align:center;';
    panel.appendChild(title);

    this._questListEl = document.createElement('div');
    this._questListEl.style.cssText = 'display:flex;flex-direction:column;gap:8px;max-height:400px;overflow-y:auto;';
    panel.appendChild(this._questListEl);

    const closeBtn = document.createElement('div');
    closeBtn.textContent = 'Cerrar';
    closeBtn.style.cssText = `
      margin-top:16px; padding:8px 0; text-align:center; cursor:pointer;
      background:#555; border:2px solid; border-color:#777 #333 #333 #777;
      font-size:14px; font-weight:bold; color:#EEE;
    `;
    closeBtn.addEventListener('click', () => this.hideLog());
    panel.appendChild(closeBtn);

    this._overlay.appendChild(panel);
    document.body.appendChild(this._overlay);
  }

  /**
   * Generate a random quest for a villager.
   */
  generateQuestFor(villager) {
    const template = QUEST_TEMPLATES[Math.floor(Math.random() * QUEST_TEMPLATES.length)];
    const quest = {
      id: this._nextId++,
      ...template,
      progress: 0,
      giverId: villager._questGiverId || null,
      desc: template.desc.replace('{count}', template.count || ''),
    };
    return quest;
  }

  /**
   * Offer a quest to the player (called when interacting with villager).
   */
  offerQuest(quest, onAccept, onReject) {
    // Build dialog UI
    const dialog = document.createElement('div');
    dialog.style.cssText = `
      position:fixed; top:50%; left:50%; transform:translate(-50%,-50%);
      background:#2A2A2A; border:4px solid #FFD700; padding:24px;
      min-width:400px; z-index:915; font-family:'Courier New',monospace; color:#DDD;
    `;
    dialog.innerHTML = `
      <div style="font-size:18px;font-weight:bold;color:#FFD700;margin-bottom:8px;">📜 ${quest.name}</div>
      <div style="font-size:13px;color:#AAA;margin-bottom:16px;">${quest.desc}</div>
      <div style="display:flex;gap:12px;margin-bottom:16px;font-size:13px;">
        <span>🪙 ${quest.reward} esmeraldas</span>
        <span>⭐ ${quest.xp} XP</span>
      </div>
    `;
    const btns = document.createElement('div');
    btns.style.cssText = 'display:flex;gap:8px;';
    const acceptBtn = document.createElement('div');
    acceptBtn.textContent = 'Aceptar';
    acceptBtn.style.cssText = 'flex:1;padding:8px;text-align:center;background:#4CAF50;cursor:pointer;font-weight:bold;';
    acceptBtn.addEventListener('click', () => {
      this.activeQuests.push(quest);
      this._updateTracker();
      dialog.remove();
      if (onAccept) onAccept();
    });
    const rejectBtn = document.createElement('div');
    rejectBtn.textContent = 'Rechazar';
    rejectBtn.style.cssText = 'flex:1;padding:8px;text-align:center;background:#8B0000;cursor:pointer;font-weight:bold;';
    rejectBtn.addEventListener('click', () => {
      dialog.remove();
      if (onReject) onReject();
    });
    btns.appendChild(acceptBtn);
    btns.appendChild(rejectBtn);
    dialog.appendChild(btns);
    document.body.appendChild(dialog);
  }

  /**
   * Progress event handlers — called from game systems.
   */
  onMobKilled(mobType) {
    for (const q of this.activeQuests) {
      if (q.type === 'kill' && q.target === mobType && q.progress < q.count) {
        q.progress++;
        this._checkCompletion(q);
      }
    }
    this._updateTracker();
  }

  onBlockMined(blockId) {
    for (const q of this.activeQuests) {
      if (q.type === 'mine' && q.blockId === blockId && q.progress < q.count) {
        q.progress++;
        this._checkCompletion(q);
      }
    }
    this._updateTracker();
  }

  onItemCollected(itemIdOrKey, count = 1) {
    for (const q of this.activeQuests) {
      if (q.type === 'gather' && q.item === itemIdOrKey) {
        q.progress = Math.min(q.count, q.progress + count);
        this._checkCompletion(q);
      }
    }
    this._updateTracker();
  }

  onDimensionVisited(dim) {
    for (const q of this.activeQuests) {
      if (q.type === 'explore' && q.target === dim) {
        q.progress = 1;
        q.count = 1;
        this._checkCompletion(q);
      }
    }
    this._updateTracker();
  }

  _checkCompletion(quest) {
    if (quest.progress >= quest.count && !quest._completed) {
      quest._completed = true;
      this.completedCount++;
      if (this.onQuestComplete) this.onQuestComplete(quest);
      // Remove from active after a short delay
      setTimeout(() => {
        const idx = this.activeQuests.indexOf(quest);
        if (idx >= 0) this.activeQuests.splice(idx, 1);
        this._updateTracker();
      }, 500);
    }
  }

  _updateTracker() {
    if (this.activeQuests.length === 0) {
      this._tracker.style.display = 'none';
      return;
    }
    this._tracker.style.display = 'block';
    const lines = this.activeQuests.slice(0, 3).map(q => {
      const pct = Math.floor((q.progress / q.count) * 100);
      const color = q._completed ? '#4CAF50' : '#FFD700';
      return `<div style="margin-bottom:4px;">
        <div style="color:${color};font-weight:bold;">${q.name}</div>
        <div style="color:#AAA;font-size:11px;">${q.progress}/${q.count} — ${pct}%</div>
      </div>`;
    });
    this._tracker.innerHTML = `<div style="font-weight:bold;color:#FFD700;margin-bottom:6px;">📜 Misiones Activas</div>` + lines.join('');
  }

  showLog() {
    this._questListEl.innerHTML = '';
    if (this.activeQuests.length === 0) {
      this._questListEl.innerHTML = '<div style="text-align:center;color:#888;">No tienes misiones activas. Habla con aldeanos.</div>';
    } else {
      for (const q of this.activeQuests) {
        const row = document.createElement('div');
        row.style.cssText = 'background:#3A3A3A;padding:12px;border-left:4px solid #FFD700;';
        row.innerHTML = `
          <div style="font-weight:bold;color:#FFD700;">${q.name}</div>
          <div style="color:#AAA;font-size:12px;margin:4px 0;">${q.desc}</div>
          <div style="font-size:11px;">Progreso: <span style="color:#4CAF50;">${q.progress}/${q.count}</span></div>
          <div style="font-size:11px;">Recompensa: 🪙 ${q.reward} esmeraldas + ⭐ ${q.xp} XP</div>
        `;
        this._questListEl.appendChild(row);
      }
    }
    this._overlay.style.display = 'flex';
    this.isOpen = true;
  }

  hideLog() {
    this._overlay.style.display = 'none';
    this.isOpen = false;
  }

  serialize() {
    return { activeQuests: this.activeQuests, completedCount: this.completedCount };
  }

  deserialize(data) {
    if (!data) return;
    this.activeQuests = data.activeQuests || [];
    this.completedCount = data.completedCount || 0;
    this._updateTracker();
  }
}
